import { PageController } from '@client/components/_core/layout/PageController';
import { ObligationEmbeddings } from '@client/components/obligations/ObligationEmbeddings';
import { createFileRoute } from '@tanstack/react-router';
import { Col, Row } from 'antd';

export const Route = createFileRoute('/console/$orgId/compliance/obligations/details/$id/debug')({
    params: {
        parse: (params: Record<string, string>) => ({
            id: BigInt(params.id),
        }),
    },
    component: ObligationDebug,
});

function ObligationDebug() {
    const { id } = Route.useParams();

    return (
        <PageController route={Route}>
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <ObligationEmbeddings obligationId={id} />
                </Col>
            </Row>
        </PageController>
    );
}
